import { IFormConroller } from 'Domain/LayoutConfiguration/types/IFormConroller';
import showSettings from 'Domain/LayoutConfiguration/models/showSettings';
import formFieldsConfigController from '../../models/formFieldsConfigController';

export default async (formId: keyof IFormConroller, typeTaskId: string) => {
    const typeId = +($$(typeTaskId) as webix.ui.richselect).getValue();
    const fieldsConfig = await formFieldsConfigController(formId, true, typeId);
    webix.ui(showSettings(fieldsConfig)).show();
};
